<template>
  <div class="confirm-view">
    <b-container>
      <section class="section section--loader" v-if="searching">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section class="section" v-else>
        <b-row>
          <b-col md="12" :xl="selected_solution.property && Object.keys(selected_solution.property.room).length > 0 ? '9' : '12'">
            <confirm-content-block
              :confirm="confirm"
            />
          </b-col>
          <b-col md="12" xl="3" v-if="selected_solution.property && Object.keys(selected_solution.property.room).length > 0">
            <resume
              v-if="Object.keys(selected_solution.property).length"
              :activate_credit_alert="false"
              :property_data="selected_solution.property"
            />
          </b-col>
        </b-row>
      </section>
    </b-container>
  </div>
</template>

<script>
import {mapState} from "vuex"
import { service_handler } from '@src/services'
import ConfirmContentBlock from '@liveeps/components/views/content-blocks/confirm'
import RoomsSummary from '@liveeps/components/blocks/resume/resume'

export default {
  name: 'confirm-view',

  components: {
    'confirm-content-block': ConfirmContentBlock,
    'resume': RoomsSummary,
  },

  props: {
    itinerary_id: String,
    confirm_code: String,
  },

  data() {
    return {
      confirm: {},
    }
  },

  computed: {
    ...mapState({
      // stato globale
      searching: state => state.searching,

      // stato del modulo liveeps
      selected_solution: state => state.liveeps.selected_solution,
    }),
  },

  created() {
  },

  mounted() {
    this.get_confirm()
  },

  methods: {
    get_confirm() {
      let params = {
        itinerary_id: this.itinerary_id,
        confirmcode: this.confirm_code
      }

      this.$store.commit('searching', true)

      service_handler(
        'confirm',
        params
      ).then(
        (success) => {
          setTimeout(() => {
            this.confirm = success.data
            this.$store.commit('searching', false)
          }, 2000)
        },
        (error) => {
          this.log(error.response)
          this.confirm = {}
          this.$store.commit('searching', false)
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>

  .confirm-view {

    .resume {
      @include media-breakpoint-up(xl){
        position: sticky;
        top: $grid-gutter-width / 2;
        margin-top: $grid-gutter-width;
      }
    }

    ::v-deep {
      .rooms-summary__title + .rooms-summary__wrap {
        display: none;
      }
    }
  }

</style>